<template>
<div>
  <section v-if="boxes && boxes.length > 0">    

    <h2 class="title is-spaced all-boxes">Iniciatives per comarca</h2>

    <div class="columns has-margin-bottom-2 is-multiline">
      <div class="column is-one-fifth">        
        <router-link :to="'/comarca/totes'" class="button" v-bind:class="{ 'is-light': territorial != '', 'is-danger': territorial == '' }">
          TOTES
        </router-link>                
      </div>

      <div class="column is-one-fifth" v-for="option in territorials" v-bind:key="option.id">        
        <router-link :to="'/comarca/' + option.url" class="button" v-bind:class="{ 'is-light': territorial != option.id, 'is-danger': territorial == option.id }">
          {{ option.description }}
        </router-link>                
      </div>
    </div>
    
    <div class="columns is-multiline is-desktop has-margin-top-3">
      <div class="column is-one-third" v-for="box in filteredBoxes" v-bind:key="box.id">        
        <BoxItemDetail :box="box" :scope="scope"></BoxItemDetail>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import { mapState } from "vuex";
import BoxItemDetail from '@/components/BoxItemDetail'
const fb = require("../firebaseConfig.js");
import { scopes } from "../services/scope.service";
import { territorial } from "../services/territorial.service";

export default {  
  components: {
    BoxItemDetail
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "boxes"]),
    filteredBoxes() {
      if (this.territorial == '') {
        return this.boxes
      }
      else {
        return this.boxes.filter(b => b.territorial == this.territorial)
      }
    },
    territorials() {
      let territorials = []
      this.boxes.forEach(b => {
        if (territorials.filter(t => t.id == b.territorial).length == 0 && b.territorial != null) {
          territorials.push( territorial.find(t => t.id == b.territorial) )
          //territorials.push(b.territorial)
        }
      })
      return territorials
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      
      if (this.$route.params.id) {
        let comarca = this.$route.params.id
        let territorial = this.allTerritorials.find(t => t.url == comarca)
        if (territorial) {
          this.setTerritorial(territorial);
        }
        else {
          this.territorial = ''
        }
      }
      else {
        this.territorial = '';
        // document.querySelector('.all-boxes').scrollIntoView({ 
        //   behavior: 'smooth' 
        // });
      }
    }
  },  
  data() {
    return {
      scopes: scopes,
      territorial: '',
      scope: '',
      allTerritorials: territorial
    }
  },
  mounted() {
    if (this.$route.params.id) {
      let comarca = this.$route.params.id
      let territorial = this.allTerritorials.find(t => t.url == comarca)
      if (territorial) {
        this.setTerritorial(territorial);
      }
      else {
        this.territorial = ''
      }
    }
  },
  methods: {
    setScope(scope) {
      this.scope = scope
    },
    setTerritorial(t) {
      console.log('t', t)
      this.territorial = t.id
      //this.$router.push("/comarca/garrotxa");
    }
  }
};
</script>
<style scoped>
section {
    padding: 2rem 0;
}
p.desc{
  font-size: 16px;
  font-family: 'Varela Round';
  color: #a3a3a3;
  line-height: 30px;
}
.scope{text-transform: uppercase;font-weight: bold;}
</style>
 


// WEBPACK FOOTER //
// src/components/AllBoxes.vue